module.exports = __webpack_public_path__ + "static/media/Intro-image2.a28c4350.jpg";